export default __webpack_public_path__ + "static/media/modal-close.3d8cde1e.svg";